// Wave-D harness — context editing (doutrina Claude: "limpe tool_results
// antigos com placeholder; o modelo re-executa a tool se precisar"). Além do
// clipe do capConversation: resultados de LEITURA de rodadas antigas viram stub
// curto — a janela deixa de carregar dumps que o modelo já consumiu. Puro; o
// loop aplica na VISÃO enviada ao modelo (s.convo intacto — por-call, reversível).

const READ_TOOLS = new Set([
  'read_file', 'grep_search', 'semantic_search', 'search_brain', 'list_files',
  'preview_console', 'preview_inspect', 'preview_screenshot',
]);
const MIN_MESSAGES = 30; // só age em conversa longa — turno curto sai intacto
const KEEP_ROUNDS = 3; // as últimas N rodadas de assistant ficam intactas
const STUB_MIN_CHARS = 500; // resultado curto não paga o stub

/** id da tool call → nome da tool (dos assistant turns do histórico). */
function buildNameIndex(messages) {
  const nameById = new Map();
  for (const m of messages) {
    if (m?.role !== 'assistant' || !Array.isArray(m.tool_calls)) continue;
    for (const tc of m.tool_calls) { if (tc?.id) nameById.set(tc.id, tc.function?.name || tc.name || 'tool'); }
  }
  return nameById;
}

/** Índice do K-ésimo assistant contando do fim (−1 se não há K). Antes dele = rodada antiga. */
function findKeepBoundary(messages, keepRounds) {
  let seen = 0;
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    if (messages[i]?.role === 'assistant') { seen += 1; if (seen >= keepRounds) return i; }
  }
  return -1;
}

function stubOldRead(m, nameById, { stubMinChars, keepRounds }) {
  if (m?.role !== 'tool' || typeof m.content !== 'string') return m;
  if (m.content.length < stubMinChars || m.content.startsWith('[resultado de ')) return m;
  const name = nameById.get(m.tool_call_id) || 'tool';
  if (!READ_TOOLS.has(name)) return m; // confirmações de escrita/exec são curtas e podem importar
  return { ...m, content: `[resultado de ${name} (${m.content.length} chars) limpo pelo harness após ${keepRounds} rodadas — re-execute a tool se precisar dele de novo]` };
}

export function editOldToolResults(messages, { minMessages = MIN_MESSAGES, keepRounds = KEEP_ROUNDS, stubMinChars = STUB_MIN_CHARS } = {}) {
  if (!Array.isArray(messages) || messages.length < minMessages) return messages;
  const boundary = findKeepBoundary(messages, keepRounds);
  if (boundary <= 0) return messages;
  const nameById = buildNameIndex(messages);
  let edited = 0;
  const out = messages.map((m, i) => {
    if (i >= boundary) return m;
    const next = stubOldRead(m, nameById, { stubMinChars, keepRounds });
    if (next !== m) edited += 1;
    return next;
  });
  return edited ? out : messages;
}
